import { Component, For, onMount } from "solid-js"
import { Artwork, Entity } from "../types";
import { createStore } from "solid-js/store";
import { fetchGet } from "../api";

type Props = {
    artwork: Artwork;
}

export const EntitiesTab : Component<Props> = ({ artwork }) => {
    const [entities, setEntities] = createStore<any[]>([]);
    const loadEntities = async () => {
        const res = await fetchGet("/Artwork/GetEntitiesFromJson", { id: artwork.id });
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        setEntities(json.Data);
    };
    onMount(async () => {
        await loadEntities();
    });
    return (
        <>
            <div class="didactic" style="margin: 0; width: 100%; background-color: #fff; text-align: left;">
                <h2 style="text-align: center;">
                    Entities in this work
                </h2>
                <ul style="margin-top: 10px; font-size: 1rem;">
                    <For each={entities}>{(item) =>
                        <li>
                            <a href={"/Entity/Index/" + item.Id}>{item.Name}</a>
                        </li>
                    }</For>
                </ul>
            </div>
        </>
    )
}